// extracted by mini-css-extract-plugin
export default {"card_list_scroll":"_1VbTYIDg-zUTtc16HIPfc-"};